import React from "react";

import "./crm-user-analytics.styles.scss";

const CRMUserAnalytics = () => (
  <div className="crmUserAnalytics-component">
    <iframe
    className="report"
    src="https://lookerstudio.google.com/embed/reporting/9d417277-a1d1-4084-861c-ac9a9ae96067/page/p_cfpxsxaf1d"

      // src="https://lookerstudio.google.com/embed/reporting/eaa463ff-aeba-49d9-bff9-6fb9652a7fca/page/p_gxz2or2xed"
      title="CRM User Analytics"
    />
  </div>
);

export default CRMUserAnalytics;
